<div class="w-80">
  <section>
    <b>What is a brand kit?</b>
    <p>The brand kit is made up of your logo and common colors and fonts that you use.</p>
  </section>
  <section>
    <b>Why should I use this?</b>
    <p>We have many places (and continuing to add them) where having this will save you time.</p>
  </section>
  <section>
    <b>Do I need to fill out everything?</b>
    <p>
      No. For example, if you don't have fonts as part of your brand, you can disregard this. However, you could add 3
      of your most commonly used fonts to help you save time in the future.
    </p>
  </section>
  <hr />
  <div class="contact-us">
    <span>If you have any questions, just let us know.</span>
    <a href="/contact/" target="_blank"> Contact Us </a>
  </div>
</div>

<style lang="postcss">
  section {
    @apply mb-8;
    font-family: 'Roboto';

    b {
      @apply mb-2 block font-bold text-gray-950;
      line-height: 18px;
    }

    p {
      @apply block text-gray-700;
    }
  }

  .contact-us {
    @apply mt-4;
    display: block;
    font-family: 'Roboto';

    span {
      @apply my-6 block text-gray-700;
    }

    a {
      @apply block w-full rounded-lg border-2 border-primary p-2 text-center font-bold text-primary hover:bg-primary hover:text-white;
    }
  }
</style>
